import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export default function ICDash({
  width,
  height,
  className,
}: ISvgIcon): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4915 0.666687H5.50817C2.47484 0.666687 0.666504 2.47502 0.666504 5.50835V12.4834C0.666504 15.525 2.47484 17.3334 5.50817 17.3334H12.4832C15.5165 17.3334 17.3248 15.525 17.3248 12.4917V5.50835C17.3332 2.47502 15.5248 0.666687 12.4915 0.666687ZM6.5915 13.0834C6.5915 13.3167 6.40817 13.5 6.17484 13.5H3.84984C3.6165 13.5 3.43317 13.3167 3.43317 13.0834V9.23335C3.43317 8.70835 3.85817 8.28335 4.38317 8.28335H6.17484C6.40817 8.28335 6.5915 8.46669 6.5915 8.70002V13.0834ZM10.5748 13.0834C10.5748 13.3167 10.3915 13.5 10.1582 13.5H7.83317C7.59984 13.5 7.4165 13.3167 7.4165 13.0834V5.45002C7.4165 4.92502 7.8415 4.50002 8.3665 4.50002H9.63317C10.1582 4.50002 10.5832 4.92502 10.5832 5.45002V13.0834H10.5748ZM14.5665 13.0834C14.5665 13.3167 14.3832 13.5 14.1498 13.5H11.8248C11.5915 13.5 11.4082 13.3167 11.4082 13.0834V10.125C11.4082 9.89169 11.5915 9.70835 11.8248 9.70835H13.6165C14.1415 9.70835 14.5665 10.1334 14.5665 10.6584V13.0834Z"
        fill="currentColor"
      />
    </svg>
  );
}
